import { type Driver, isWebDataSuccess, type WebData } from '@cobliteam/api-lib';
import type { UUID, Vehicle } from '@cobliteam/common-types';
import { type AppState, loadDriversRequest, loadVehiclesRequest, selectDriversById, selectVehiclesById } from '@cobliteam/store';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import RoutesHistoryContainer from '../../containers/RoutesHistory';

type OwnProps = {};

interface DispatchProps {
  loadPageContent: () => void;
}

interface StateProps {
  driversById: Map<UUID, Driver>;
  vehiclesById: Map<UUID, Vehicle>;
}

const valueOrEmpty = <T, U>(webData: WebData<Map<T, U>>): Map<T, U> => (isWebDataSuccess(webData) ? webData.data : new Map());

const mapStateToProps = (state: AppState): StateProps => ({
  driversById: valueOrEmpty(selectDriversById(state)),
  vehiclesById: valueOrEmpty(selectVehiclesById(state)),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  loadPageContent: () => {
    dispatch(loadDriversRequest());
    dispatch(loadVehiclesRequest());
  },
});

const TrackingHistoryPage = connect<StateProps, DispatchProps, OwnProps, AppState>(mapStateToProps, mapDispatchToProps)(RoutesHistoryContainer);

export default TrackingHistoryPage;
